import React from 'react';
import star from "assets/images/star.svg";
import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <div className="outer-white mission-div">
            <div className="mt-2 ">
                <div className="disaster-card mx-auto text-center">
                    <div className="alert-distaster mx-auto">
                        <img src={star} alt="star" />
                    </div >
                    <h2>404 Not Found!</h2>
                    <Link to="/dashboard" className="btn btn-primary text-white mt-4">
                        Go To Home
                    </Link>
                </div >
            </div >
        </div >
    )
}

export default NotFound